"use strict";
/**
 *
 *
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var axios_1 = __importDefault(require("axios"));
var AppConfig_1 = require("../AppConfig");
var BaseRepository = /** @class */ (function () {
    function BaseRepository(schemaName, tableId) {
        this._processTextResponse = null;
        this._schemaName = schemaName;
        this._tableId = tableId;
        this._metaUrl = "/api/db/" + schemaName + "." + tableId + "/";
    }
    BaseRepository.prototype.create = function (entity) {
        return this._doRequest('POST', undefined, this._pack(entity));
    };
    BaseRepository.prototype.list = function () {
        return this._doRequest('GET');
    };
    BaseRepository.prototype.find = function (expr) {
        return this._doRequest('GET', undefined, undefined, expr);
    };
    BaseRepository.prototype.getById = function (id) {
        return this._doRequest('GET', id);
    };
    BaseRepository.prototype.update = function (id, entity) {
        return this._doRequest('PUT', id, this._pack(entity));
    };
    BaseRepository.prototype.remove = function (id) {
        return this._doRequest('DELETE', id);
    };
    BaseRepository.prototype.getSchemaName = function () {
        return this._schemaName;
    };
    BaseRepository.prototype.getTableName = function () {
        return this._tableId;
    };
    BaseRepository.prototype._getUrl = function (method, id) {
        var url = AppConfig_1.AppConfig.fixRequestUrl(this._metaUrl + (id == null ? '' : id.toString()));
        return url;
    };
    // TODO: use comparator (e1, e2) => 0 instead of
    BaseRepository.prototype._sort = function (es) {
        // do nothing
    };
    BaseRepository.prototype._unpack = function (e) {
        return e;
    };
    BaseRepository.prototype._pack = function (e) {
        return e;
    };
    BaseRepository.prototype._filter = function (e) {
        return true;
    };
    BaseRepository.createExpression = function (expression) {
        if (!expression)
            return undefined;
        var result = '';
        if ('filter' in expression) {
            var filter_1 = expression.filter;
            var createFilter = function (k) {
                return typeof filter_1[k] === 'string' ? k + "='" + filter_1[k] + "'" : k + "=" + filter_1[k];
            };
            result +=
                '.filter(' +
                    Object.keys(filter_1)
                        .map(createFilter)
                        .join('&&') +
                    ')';
        }
        if ('slice' in expression) {
            var slice = expression.slice;
            result += ".slice(" + slice[0] + ", " + slice[1] + ")";
        }
        return result;
    };
    BaseRepository.prototype._doRequest = function (method, id, body, expression) {
        return __awaiter(this, void 0, void 0, function () {
            var expr, url, requestParams, response, err_1, result, textResponse, processedTextResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        expr = BaseRepository.createExpression(expression);
                        url = this._getUrl(method, expr || id);
                        requestParams = {
                            method: method,
                            url: url
                        };
                        if (body) {
                            requestParams.data = body;
                            requestParams.headers = {
                                'Content-Type': 'application/json'
                            };
                        }
                        if (this._processTextResponse) {
                            requestParams.transformResponse = function (res) { return res; };
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1["default"](requestParams)];
                    case 2:
                        response = (_a.sent()).data;
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1.isAxiosError && err_1.response.status === 404) {
                            console.warn('Got 404 response on repository', err_1);
                            response = [];
                        }
                        else {
                            throw err_1;
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (this._processTextResponse) {
                            console.assert(typeof response === 'string');
                            textResponse = response;
                            processedTextResponse = this._processTextResponse(textResponse);
                            result = JSON.parse(processedTextResponse);
                        }
                        else {
                            result = response;
                        }
                        if (id == null && Array.isArray(result)) {
                            this._sort(result);
                            result = result.filter(this._filter);
                        }
                        if (id != null && Array.isArray(result)) {
                            // requested entity, but returned array => take 1st element
                            result = result[0] || null;
                        }
                        if (method == 'DELETE')
                            return [2 /*return*/, result];
                        if (Array.isArray(result)) {
                            result = result.map(this._unpack);
                        }
                        else if (null !== result) {
                            result = this._unpack(result);
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return BaseRepository;
}());
exports.BaseRepository = BaseRepository;
